import React from 'react';
import classnames from 'classnames';
import { Col, Card, CardHeader, CardBody, Collapse } from 'reactstrap';
import placeholderImage from '../../../../assets/images/placeholder.jpg';
import { to12Hr } from '../../../../helpers/moment';
import './styles.css';

const ClientDetails = React.memo(
  ({
    clientDetails,
    activeSchedules,
    fillRates,
    activeShift,
    setActiveShift,
    fetchClientDetailsByScheduleId,
  }) => {
    const [accordionState, setAccordionState] = React.useState({});

    const toggleAccordion = (siteId) => {
      setAccordionState((prevState) => {
        const isCurrentlyOpen = prevState[siteId];

        if (!isCurrentlyOpen) {
          const firstShift = fillRates?.find(
            (shift) =>
              shift.site_id === siteId &&
              activeSchedules.some(
                (siteSchedule) =>
                  siteSchedule.site_id === siteId &&
                  shift.id === siteSchedule.shift_id
              )
          );

          if (firstShift) {
            handleChangeShift(
              firstShift.id,
              firstShift.schedule?.id,
              siteId
            );
          }
        }

        return isCurrentlyOpen ? {} : { [siteId]: true };
      });
    };

    const handleChangeShift = (shift_id, schedule_id, site_id) => {
      fetchClientDetailsByScheduleId(schedule_id, site_id);
      setActiveShift(shift_id);
    };

    return (
      <Col className="row  mx-1">
        <h6 className="text-start mb-3">Attendance Summary</h6>
        {clientDetails.length > 0 ? (
          clientDetails.map((client) => (
            <Card
              className="card-h-100 mb-4 rounded-1 mx-0 px-0"
              key={client.client_id}
            >
              <CardHeader className="my-2">
                <h6 className="card-title mb-1">{client.client_name}</h6>
                <p className="text-muted adjust-fs">
                  Display client’s attendance summary.
                </p>
              </CardHeader>
              <CardBody className="p-0">
                <div
                  className="accordion my-2 mx-4 mb-4"
                  id="accordionFlushExample"
                >
                  {client.sites?.map((site) => (
                    <div className="accordion-item" key={site.site_id}>
                      <p
                        className="accordion-header"
                        id={`headingFlush${site.site_id}`}
                      >
                        <button
                          className={classnames(
                            'accordion-button',
                            'fw-medium',
                            {
                              collapsed: !accordionState[site.site_id],
                            }
                          )}
                          type="button"
                          onClick={() => toggleAccordion(site.site_id)}
                          style={{ cursor: 'pointer' }}
                        >
                          {site.site_name}
                        </button>
                      </p>
                      <Collapse
                        isOpen={accordionState[site.site_id]}
                        className="accordion-collapse"
                      >
                        <div className="accordion-body">
                          <div className="d-flex flex-wrap gap-3">
                            {/* Card for 'Allocated' */}
                            {/* <div className="adjust-client-card border rounded-1 adjust-shadow">
                              <h6 className="card-title pt-1 text-muted mt-2">
                                Allocated
                              </h6>
                              <p className="card-text text-end fs-4 fw-bold pe-4">
                                {site.allocated ?? 0}
                              </p>
                            </div> */}
                            {/* Card for 'Assigned' */}
                            <div className="adjust-client-card border rounded-1 adjust-shadow">
                              <h6 className="card-title pt-1 text-muted mt-2">
                                Assigned
                              </h6>
                              <p className="card-text text-end fs-4 fw-bold pe-4">
                                {site.assigned ?? 0}
                              </p>
                            </div>
                            {/* Card for 'Present' */}
                            <div className="adjust-client-card adjust-client-card-green border rounded-1 adjust-shadow">
                              <h6 className="card-title pt-1 text-white mt-2">
                                Present
                              </h6>
                              <p className="card-text text-end fs-4 fw-bold pe-4 text-white">
                                {site.present ?? 0}
                              </p>
                            </div>
                            {/* Card for 'Absent' */}
                            <div className="adjust-client-card adjust-client-card-red border rounded-1 adjust-shadow">
                              <h6 className="card-title pt-1 text-white mt-2">
                                Absent
                              </h6>
                              <p className="card-text text-end fs-4 fw-bold pe-4 text-white">
                                {site.absent ?? 0}
                              </p>
                            </div>
                          </div>
                          {/* List of Associates */}
                          <div className="d-flex flex-row col-md-12 p-4">
                            <div className="row col-md-3 pe-4">
                              {fillRates ? ( // Fill Rate
                                fillRates
                                  .filter(
                                    (shifts) =>
                                      shifts.site_id === site.site_id &&
                                      activeSchedules.some(
                                        (siteSchedule) =>
                                          siteSchedule.site_id ===
                                            site.site_id &&
                                          shifts.id === siteSchedule.shift_id
                                      )
                                  )
                                  .map((shift, index) => (
                                    <div
                                      key={index}
                                      className="d-flex align-items-bottom flex-column me-4 mb-4"
                                    >
                                      <div className="d-flex flex-row justify-content-between">
                                        <p>
                                          {shift.name ? shift.name : 'Unknown'}
                                        </p>
                                        {shift.schedule &&
                                        shift.schedule !== null ? (
                                          <p>
                                            <span className="percentage me-2">
                                              {' '}
                                              {isNaN(
                                                (
                                                  (fillRates.find(
                                                    (rate) =>
                                                      rate.id === shift.id
                                                  ).schedule?.filled_slots /
                                                    fillRates.find(
                                                      (rate) =>
                                                        rate.id === shift.id
                                                    ).schedule.slots.slots) *
                                                  100
                                                ).toFixed(2)
                                              ) ||
                                              fillRates.find(
                                                (rate) => rate.id === shift.id
                                              ).schedule.slots.slots === 0
                                                ? '0.00'
                                                : (
                                                    (fillRates.find(
                                                      (rate) =>
                                                        rate.id === shift.id
                                                    ).schedule.filled_slots /
                                                      fillRates.find(
                                                        (rate) =>
                                                          rate.id === shift.id
                                                      ).schedule.slots.slots) *
                                                    100
                                                  ).toFixed(2)}
                                              %{' '}
                                            </span>
                                            <span className={`slots`}>
                                              {fillRates !== null &&
                                              fillRates?.length > 0 ? (
                                                <React.Fragment>
                                                  (
                                                  {
                                                    fillRates.find(
                                                      (rate) =>
                                                        rate.id === shift.id
                                                    ).schedule.filled_slots
                                                  }
                                                  /
                                                  {
                                                    fillRates.find(
                                                      (rate) =>
                                                        rate.id === shift.id
                                                    ).schedule.slots.slots
                                                  }
                                                  )
                                                </React.Fragment>
                                              ) : (
                                                '0.00'
                                              )}
                                            </span>
                                          </p>
                                        ) : (
                                          <p>
                                            <span className="percentage me-2">
                                              0%{' '}
                                            </span>
                                            <span className="slots">(0/0)</span>
                                          </p>
                                        )}
                                      </div>
                                      <button
                                        onClick={() =>
                                          handleChangeShift(
                                            shift?.id,
                                            shift.schedule?.id,
                                            site.site_id
                                          )
                                        }
                                        className={`${
                                          activeShift === shift.id
                                            ? 'btn btn-brand'
                                            : 'btn btn-secondary'
                                        } adjust-btn-shifts`}
                                      >
                                        {to12Hr(shift.start_time)} -{' '}
                                        {to12Hr(shift.end_time)}
                                      </button>
                                    </div>
                                  ))
                              ) : (
                                <h6 className="text-muted mt-4">Loading...</h6>
                              )}
                            </div>
                            <div className="row col-md-9 associate-container">
                              {site.associates?.map((associate, index) => (
                                <div
                                  key={index}
                                  className="non-team-support col-sm-3 p-2"
                                >
                                  <div
                                    className="form-check form-check-inline"
                                    style={{ marginLeft: 12, marginRight: 7 }}
                                  ></div>
                                  <div className="">
                                    <img
                                      className="img-responsive rounded-circle border"
                                      style={{ width: '45px', height: '45px' }}
                                      src={
                                        associate.image
                                          ? `${SERVER_URL}/${associate.image}`
                                          : placeholderImage
                                      }
                                      alt="username-img"
                                      onError={(e) => {
                                        e.target.onerror = null;
                                        e.target.src =
                                          'https://t3.ftcdn.net/jpg/00/64/67/80/240_F_64678017_zUpiZFjj04cnLri7oADnyMH0XBYyQghG.jpg';
                                      }}
                                    />
                                  </div>
                                  <div>
                                    <p>
                                      {`${associate.first_name} ${associate.last_name}`}
                                    </p>
                                  </div>
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                      </Collapse>
                    </div>
                  ))}
                </div>
              </CardBody>
            </Card>
          ))
        ) : (
          <div className="text-center text-muted">
            <p>No attendance record found.</p>
          </div>
        )}
      </Col>
    );
  }
);

export default ClientDetails;
